import { render, staticRenderFns } from "./GeomagneticHistoricalDetail.vue?vue&type=template&id=310301a3&scoped=true&"
import script from "./GeomagneticHistoricalDetail.vue?vue&type=script&lang=js&"
export * from "./GeomagneticHistoricalDetail.vue?vue&type=script&lang=js&"
import style0 from "./GeomagneticHistoricalDetail.vue?vue&type=style&index=0&id=310301a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310301a3",
  null
  
)

export default component.exports